(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["na-blog-series"] && !Shopify.designMode) return;
  try {
    
(() => {
  const queue = [];
  const requests = new Map();
  let active = 0;

  const readCover = async (url) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Category cover unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = html.querySelector('template[data-na-latest-cover]');
      return template ? template.cloneNode(true) : null;
    } finally {
      clearTimeout(timeout);
    }
  };

  const update = async (card) => {
    const url = new URL(card.dataset.naCategoryCoverUrl, window.location.origin);
    if (url.origin !== window.location.origin) return;
    url.searchParams.set('section_id', 'na-category-cover');
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    card.dataset.naCoverStatus = 'loading';
    try {
      const key = url.href;
      if (!requests.has(key)) requests.set(key, readCover(key));
      const template = await requests.get(key);
      card.dataset.naCoverArticle = template?.dataset.article || '';
      const badge = card.querySelector('[data-blog-published-at]');
      if (badge && template) {
        badge.dataset.blogPublishedAt = template.dataset.publishedAt || '0';
        badge.dispatchEvent(new Event('blog:published-at', { bubbles: true }));
      }
      const image = template?.content.querySelector('img');
      if (!image) {
        card.dataset.naCoverStatus = 'fallback';
        return;
      }
      const replacement = image.cloneNode(true);
      const previous = card.querySelector('img');
      replacement.addEventListener('error', () => {
        if (previous) replacement.replaceWith(previous);
        else replacement.remove();
        card.dataset.naCoverStatus = 'fallback';
      }, { once: true });
      if (previous) previous.replaceWith(replacement);
      else card.prepend(replacement);
      card.dataset.naCoverStatus = 'ready';
    } catch {
      card.dataset.naCoverStatus = 'fallback';
    }
  };

  const drain = () => {
    while (active < 2 && queue.length) {
      const card = queue.shift();
      active += 1;
      update(card).finally(() => {
        active -= 1;
        drain();
      });
    }
  };

  const enqueue = (card) => {
    queue.push(card);
    drain();
  };

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        enqueue(entry.target);
      }
    });
  }, { rootMargin: '300px' }) : null;

  const initialize = (root) => {
    root.querySelectorAll('[data-na-category-cover-url]').forEach((card) => {
      if (card.dataset.naCoverStatus) return;
      card.dataset.naCoverStatus = 'waiting';
      if (observer) observer.observe(card);
      else enqueue(card);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordic-offer-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nordic-offer-slider')) {
    customElements.define('nordic-offer-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.slides = [...this.querySelectorAll('[data-offer-slide]')];
        this.dots = [...this.querySelectorAll('[data-slide-index]')];
        this.current = 0;
        this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        if (this.slides.length < 2) return;
        this.querySelector('.nordic-offers__controls').hidden = false;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {this.pause(); this.show(this.current + Number(button.dataset.step));}, options));
        this.dots.forEach(button => button.addEventListener('click', () => {this.pause(); this.show(Number(button.dataset.slideIndex));}, options));
        this.querySelector('[data-toggle]')?.addEventListener('click', () => {this.paused = !this.paused; this.update();}, options);
        this.addEventListener('mouseenter', () => {this.hovered = true; this.update();}, options);
        this.addEventListener('mouseleave', () => {this.hovered = false; this.update();}, options);
        this.addEventListener('focusin', () => {this.focused = true; this.update();}, options);
        this.addEventListener('focusout', event => {if (!this.contains(event.relatedTarget)) {this.focused = false; this.update();}}, options);
        this.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault(); this.pause(); this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));}}, options);
        this.addEventListener('shopify:block:select', event => {const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (index >= 0) {this.pause(); this.show(index);}}, options);
        document.addEventListener('visibilitychange', () => this.update(), options);
        this.update();
      }
      show(index) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {slide.hidden = i !== this.current;});
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
      }
      pause() {this.paused = true; this.update();}
      update() {
        clearInterval(this.timer);
        const toggle = this.querySelector('[data-toggle]');
        if (toggle) toggle.textContent = this.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        this.querySelector('.nordic-offers__slides').setAttribute('aria-live', this.paused ? 'polite' : 'off');
        if (!this.paused && !this.hovered && !this.focused && !document.hidden) this.timer = setInterval(() => this.show(this.current + 1), Number(this.dataset.interval) || 8000);
      }
      disconnectedCallback() {clearInterval(this.timer); this.abort?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
